import { render, staticRenderFns } from "./KYC2Auth.vue?vue&type=template&id=2055a170&scoped=true"
import script from "./KYC2Auth.vue?vue&type=script&lang=js"
export * from "./KYC2Auth.vue?vue&type=script&lang=js"
import style0 from "./KYC2Auth.vue?vue&type=style&index=0&id=2055a170&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2055a170",
  null
  
)

export default component.exports